export function hideEnquiryWhenZero() {
    const counts = document.querySelectorAll('.js-inquiryBasketCount');
    counts.forEach((countEl) => {
        const target = countEl.closest('.iconbarItem.js-headerEnquiryBasket') || countEl.parentElement;
        if (!target) return;

        const apply = (element) => {
            const value = (element.textContent || '').trim();
            if (value !== '0' && value !== '') {
                target.style.opacity = '1';
                target.style.pointerEvents = 'auto';
                if (screen.width < 1249.98) {
                    target.style.display = 'flex';
                }
            } else {
                target.style.opacity = '0';
                target.style.pointerEvents = 'none';
                if (screen.width < 1249.98) {
                    target.style.display = 'none';
                }
            }
        };

        apply(countEl);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                // Falls das Element ersetzt wurde, suchen wir es im Parent neu
                const currentCountEl = target.querySelector('.js-inquiryBasketCount');
                if (currentCountEl) {
                    apply(currentCountEl);
                }
            });
        });

        // Wir beobachten den Container, der stabil bleibt
        observer.observe(target, { childList: true, subtree: true, characterData: true });
    });
}